"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDownloadPopUpEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const validators_1 = require("../GS/validators");
const ValidationError_1 = require("../GS/ValidationError");
const AppDownloadPopUpDto_1 = require("./AppDownloadPopUpDto");
const AppDto_1 = require("../apps/AppDto");
const AppEntity_1 = require("../apps/AppEntity");
class AppDownloadPopUpEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, appDownloadPopUp) {
        super();
        this._requiredFieldsSetStatus = {
            downloadLink: false,
            mainText: false,
            secondaryText: false,
            featureText1: false,
            featureText2: false,
            featureText3: false,
            featureText4: false,
            finalText: false,
            featureTextColor: false,
            finalTextColor: false,
            mainTextColor: false,
            backgroundColor: false,
            appId: false,
            expireSession: false
        };
        this._dependencies = dependencies;
        if (appDownloadPopUp === undefined) {
            this._dto = new AppDownloadPopUpDto_1.AppDownloadPopUpDto();
        }
        else if (appDownloadPopUp instanceof AppDownloadPopUpDto_1.AppDownloadPopUpDto) {
            this._dto = new AppDownloadPopUpDto_1.AppDownloadPopUpDto(appDownloadPopUp);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (appDownloadPopUp instanceof AppDownloadPopUpEntity) {
            this._dto = new AppDownloadPopUpDto_1.AppDownloadPopUpDto(appDownloadPopUp._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new AppDownloadPopUpDto_1.AppDownloadPopUpDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getApp() {
        if (this._dto.appId === undefined) {
            return undefined;
        }
        if (this._dto.app === undefined) {
            throw new Error("Cannot call getApp without first loading the App.");
        }
        if (!this._appEntity && this._dto.app) {
            this._appEntity = new AppEntity_1.AppEntity(this._dependencies, this._dto.app);
        }
        return this._appEntity;
    }
    getAppId() {
        return this._dto.appId;
    }
    setApp(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppDto_1.AppDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppId(untrustedId);
        if (this.hasError("appId")) {
            return;
        }
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            this._appEntity = untrustedValue;
        }
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        this._requiredFieldsSetStatus.appId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appId", "App is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        delete this._appEntity;
        this._setIsDirty(true);
    }
    getDownloadLink() {
        return this._dto.downloadLink;
    }
    setDownloadLink(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("downloadLink");
        this._requiredFieldsSetStatus.downloadLink = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("downloadLink", "Download Link is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("downloadLink", `Download Link has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.downloadLink) {
            return;
        }
        this._dto.downloadLink = _untrustedValue;
        this._setIsDirty(true);
    }
    getMainText() {
        return this._dto.mainText;
    }
    setMainText(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("mainText");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("mainText", `Main Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.mainText) {
            return;
        }
        this._dto.mainText = _untrustedValue;
        this._setIsDirty(true);
    }
    getSecondaryText() {
        return this._dto.secondaryText;
    }
    setSecondaryText(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("secondaryText");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("secondaryText", `Secondary Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.secondaryText) {
            return;
        }
        this._dto.secondaryText = _untrustedValue;
        this._setIsDirty(true);
    }
    getFeatureText1() {
        return this._dto.featureText1;
    }
    setFeatureText1(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("featureText1");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("featureText1", `Feature Text 1 has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.featureText1) {
            return;
        }
        this._dto.featureText1 = _untrustedValue;
        this._setIsDirty(true);
    }
    getFeatureText2() {
        return this._dto.featureText2;
    }
    setFeatureText2(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("featureText2");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("featureText2", `Feature Text 2 has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.featureText2) {
            return;
        }
        this._dto.featureText2 = _untrustedValue;
        this._setIsDirty(true);
    }
    getFeatureText3() {
        return this._dto.featureText3;
    }
    setFeatureText3(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("featureText3");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("featureText3", `Feature Text 3 has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.featureText3) {
            return;
        }
        this._dto.featureText3 = _untrustedValue;
        this._setIsDirty(true);
    }
    getFeatureText4() {
        return this._dto.featureText4;
    }
    setFeatureText4(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("featureText4");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("featureText4", `Feature Text 4 has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.featureText4) {
            return;
        }
        this._dto.featureText4 = _untrustedValue;
        this._setIsDirty(true);
    }
    getFinalText() {
        return this._dto.finalText;
    }
    setFinalText(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("finalText");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("finalText", `Final Text has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.finalText) {
            return;
        }
        this._dto.finalText = _untrustedValue;
        this._setIsDirty(true);
    }
    getFeatureTextColor() {
        return this._dto.featureTextColor;
    }
    setFeatureTextColor(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("featureTextColor");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("featureTextColor", `Feature Text Color has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.featureTextColor) {
            return;
        }
        this._dto.featureTextColor = _untrustedValue;
        this._setIsDirty(true);
    }
    getFinalTextColor() {
        return this._dto.finalTextColor;
    }
    setFinalTextColor(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("finalTextColor");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("finalTextColor", `Final Text Color has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.finalTextColor) {
            return;
        }
        this._dto.finalTextColor = _untrustedValue;
        this._setIsDirty(true);
    }
    getMainTextColor() {
        return this._dto.mainTextColor;
    }
    setMainTextColor(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("mainTextColor");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("mainTextColor", `Main Text Color has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.mainTextColor) {
            return;
        }
        this._dto.mainTextColor = _untrustedValue;
        this._setIsDirty(true);
    }
    getBackgroundColor() {
        return this._dto.backgroundColor;
    }
    setBackgroundColor(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("backgroundColor");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("backgroundColor", `Background Color has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.backgroundColor) {
            return;
        }
        this._dto.backgroundColor = _untrustedValue;
        this._setIsDirty(true);
    }
    getExpireSession() {
        return this._dto.expireSession;
    }
    setExpireSession(untrustedValue) {
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("expireSession");
        this._requiredFieldsSetStatus.expireSession = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("expireSession", "Expires Session is required."));
        }
        else if (!isFutureDate(_untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("expireSession", "Expires Session must be a future date."));
        }
        if (!this.isNew && _untrustedValue === this._dto.expireSession) {
            return;
        }
        this._dto.expireSession = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAppAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppId()) {
                    return;
                }
                this._emit("before-loadAppAsync");
                this._dto.app = yield this._dependencies.appDatastore
                    .getAsync(this.getAppId(), expand);
                delete this._appEntity;
                this._emit("after-loadAppAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.appDownloadPopUpDatastore
                    .getAsync(id, expand);
                delete this._appEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("App Download Pop Up is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.appDownloadPopUpDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.appDownloadPopUpDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("App Download Pop Up cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.appDownloadPopUpDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.AppDownloadPopUpEntity = AppDownloadPopUpEntity;
function isFutureDate(dateToTest) {
    const date = new Date(dateToTest);
    const now = new Date();
    return date > now;
}
//# sourceMappingURL=AppDownloadPopUpEntity.js.map